import React from 'react';

function Bracket({ bracket }) {
  if (!bracket) return null;

  const getRoundName = (roundIndex, totalRounds) => {
    const roundsLeft = totalRounds - roundIndex;
    if (roundsLeft === 1) return 'Finale';
    if (roundsLeft === 2) return 'Halbfinale';
    if (roundsLeft === 3) return 'Viertelfinale';
    if (roundsLeft === 4) return 'Achtelfinale';
    return `Runde ${roundIndex + 1}`;
  };

  const rounds = [];
  const totalRounds = bracket.rounds;
  for (let r = 0; r <= bracket.currentRound; r++) {
    const roundMatches = bracket.matches.filter(m => m.round === r);
    rounds.push(roundMatches);
  }

  return (
    <div className="bracket-container">
      <div className="bracket-rounds">
        {rounds.map((roundMatches, roundIndex) => (
          <div key={roundIndex} className="bracket-round">
            <div className="bracket-round-header">
              <h4 className="bracket-round-title">
                {getRoundName(roundIndex, totalRounds)}
              </h4>
              <span className="bracket-round-count">{roundMatches.length} Matches</span>
            </div>
            <div className="bracket-matches">
              {roundMatches.map((match) => (
                <div key={match.id} className={`bracket-match ${match.winner ? 'completed' : 'active'}`}>
                  <div className={`bracket-song ${match.winner === 'a' ? 'winner' : match.winner === 'b' ? 'loser' : ''}`}>
                    {match.songA ? (
                      <>
                        <img src={match.songA.albumCover} alt="" className="bracket-cover" />
                        <div className="bracket-song-info">
                          <span className="bracket-song-name">{match.songA.name}</span>
                          <span className="bracket-song-artist">{match.songA.artist}</span>
                        </div>
                        {match.votes && <span className="bracket-votes">{match.votes.a}</span>}
                      </>
                    ) : (
                      <span className="bracket-bye">Freilos</span>
                    )}
                  </div>
                  <div className="bracket-vs">VS</div>
                  <div className={`bracket-song ${match.winner === 'b' ? 'winner' : match.winner === 'a' ? 'loser' : ''}`}>
                    {match.songB ? (
                      <>
                        <img src={match.songB.albumCover} alt="" className="bracket-cover" />
                        <div className="bracket-song-info">
                          <span className="bracket-song-name">{match.songB.name}</span>
                          <span className="bracket-song-artist">{match.songB.artist}</span>
                        </div>
                        {match.votes && <span className="bracket-votes">{match.votes.b}</span>}
                      </>
                    ) : (
                      <span className="bracket-bye">Freilos</span>
                    )}
                  </div>
                  {match.winner && (
                    <div className="bracket-winner-badge">
                      🏆 {match.winner === 'a' ? match.songA?.name : match.songB?.name}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Bracket;
